import React, { memo } from 'react'

import { Icon, RotatingSpinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'

const spinnerSize = { height: '32px', width: '32px' }

function Loading() {
  return (
    <div className="variations-tab__loading">
      <Icon svgComponent={RotatingSpinner} color="primary" size={spinnerSize} notSpaced />
    </div>
  )
}

export default memo(Loading)
